import { EVENT } from "@/data/content";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="relative border-t border-[#D4AF37]/15 bg-[#070707] py-14 px-6 md:px-12"
  >
    <div className="max-w-[1300px] mx-auto grid md:grid-cols-3 gap-8 md:gap-12 items-baseline">
      <div>
        <div
          className="font-serif-display text-[#FDFBF7] text-3xl tracking-tight"
        >
          {EVENT.brand}
        </div>
        <div className="overline mt-2">{EVENT.tagline}</div>
      </div>
      <div className="text-center md:text-center">
        <p className="text-[#A3A3A3] text-sm tracking-wide">
          {EVENT.dateLong} · {EVENT.time}
        </p>
        <p className="text-[#A3A3A3] text-sm tracking-wide mt-1">{EVENT.address}</p>
        <p className="text-[#A3A3A3] text-sm tracking-wide mt-1">{EVENT.city}</p>
      </div>
      <div className="md:text-right">
        <p className="text-[#7a7a7a] text-xs tracking-[0.3em] uppercase">
          By invitation only
        </p>
        <p className="text-[#A3A3A3] text-sm mt-2">
          © {new Date().getFullYear()} 33 RPM. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);
